import { useState } from "react";

import { HardwareRequestStatus } from "src/api/types.generated";

export const useRequestActions = () => {
  const [printingRequests, setPrintingRequests] = useState<Set<number>>(
    new Set()
  );
  const [updatingRequests, setUpdatingRequests] = useState<Set<number>>(
    new Set()
  );
  const [selectedStatuses, setSelectedStatuses] = useState<
    Record<number, HardwareRequestStatus>
  >({});

  const handlePrintLabel = async (
    requestId: number,
    requestData: any,
    onPrintLabel?: (requestId: number, requestData: any) => void
  ) => {
    if (!onPrintLabel) return;

    setPrintingRequests((prev) => new Set(prev).add(requestId));
    try {
      await onPrintLabel(requestId, requestData);
    } finally {
      setPrintingRequests((prev) => {
        const newSet = new Set(prev);
        newSet.delete(requestId);
        return newSet;
      });
    }
  };

  const handleStatusUpdate = async (
    requestId: number,
    status: HardwareRequestStatus,
    onUpdateStatus: (requestId: number, status: HardwareRequestStatus) => void
  ) => {
    setUpdatingRequests((prev) => new Set(prev).add(requestId));
    try {
      await onUpdateStatus(requestId, status);
    } finally {
      setUpdatingRequests((prev) => {
        const newSet = new Set(prev);
        newSet.delete(requestId);
        return newSet;
      });
    }
  };

  const handleStatusChange = (
    requestId: number,
    newStatus: HardwareRequestStatus
  ) => {
    setSelectedStatuses((prev) => ({
      ...prev,
      [requestId]: newStatus,
    }));
  };

  const handleUpdateStatus = async (
    requestId: number,
    onUpdateStatus: (requestId: number, status: HardwareRequestStatus) => void
  ) => {
    const newStatus = selectedStatuses[requestId];
    if (!newStatus) return;

    await handleStatusUpdate(requestId, newStatus, onUpdateStatus);
    // Clear the selection after update
    setSelectedStatuses((prev) => {
      const newState = { ...prev };
      delete newState[requestId];
      return newState;
    });
  };

  return {
    printingRequests,
    updatingRequests,
    selectedStatuses,
    handlePrintLabel,
    handleStatusUpdate,
    handleStatusChange,
    handleUpdateStatus,
  };
};
